import Loader from "components/Common/Loader";
import MainContentLoader, {
  DashboardContentLoadingContext,
} from "components/Common/MainContentLoader";
import { ComponentType, Suspense, useContext } from "react";

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const Loadable = <P extends object>(Component: ComponentType<P>) => {
  function LoadableComponent(props: P) {
    const isDashboardContent = useContext(DashboardContentLoadingContext);

    return (
      <Suspense
        fallback={isDashboardContent ? <MainContentLoader /> : <Loader open />}
      >
        <Component {...props} />
      </Suspense>
    );
  }

  return LoadableComponent;
};

export default Loadable;
